export default {
  primary: {
    margin: {
      top: '0',
      right: '1.875rem',
      bottom: '0',
      left: '1.875rem',
    },
    mobile: {
      margin: {
        top: '0',
        right: '0.9375rem',
        bottom: '0',
        left: '0.9375rem',
      },
    },
    price: {
      margin: {
        top: '1.5rem',
      },
      dollarSign: {
        top: '2rem',
        fontSize: '1.75rem',
      },
      cents: {
        top: '2rem',
        fontSize: '1.75rem',
      },
      dollars: {
        fontSize: '5rem',
      },
    },
  },
  padding: {
    top: '1.875rem',
    right: '1.875rem',
    bottom: '0.9375rem',
    left: '1.875rem',
  },
  margin: {
    bottom: '1.875rem',
    top: '1.875rem',
  },
  boxShadow: 'rgba(0, 0, 0, 0.1) 6px 6px 15px 7px',
  price: {
    margin: {
      top: '1.5rem',
    },
    dollarSign: {
      top: '.7rem',
      fontSize: '1.5rem',
      left: '-1.5rem',
      french: {
        right: '-3rem',
      },
    },
    cents: {
      top: '.7rem',
      fontSize: '1.5rem',
      right: '-1.75rem',
    },
    dollars: {
      fontSize: '3.4375rem',
    },
    mobile: {
      fontSize: '0.5rem',
      margin: {
        right: '3rem',
      },
      dollarSign: {
        left: '-0.75rem',
        top: '0.3125rem',
        fontSize: '0.875rem',
      },
      cents: {
        right: '-1rem',
        top: '0.25rem',
        fontSize: '0.75rem',
        rightFrench: '-1.75rem',
      },
      dollars: {
        fontSize: '1.75rem',
      },
    },
  },
  title: {
    lineHeight: '1.625rem',
    margin: {
      right: '0.9375rem',
      bottom: '1rem',
    },
    mobile: {
      fontSize: '1rem',
    },
  },
  frequency: {
    margin: {
      bottom: '1rem',
    },
  },
  coverage: {
    padding: {
      top: '1.25rem',
    },
    mobile: {
      border: {
        top: {
          thickness: '0.03125rem',
          style: 'solid',
        },
        left: {
          thickness: '0.03125rem',
          style: 'solid',
        },
      },
      padding: {
        top: '1.25rem',
        right: '1.25rem',
        bottom: '1.875rem',
        left: '1.25rem',
      },
      margin: {
        top: '1.25rem',
        right: '-0.9375rem',
        bottom: '-16px',
        left: '-0.9375rem',
      },
    },
  },
  description: {
    lineHeight: '1.5rem',
  },
  feature: {
    lineHeight: '1.5rem',
    margin: {
      top: '0.9375rem',
    },
    padding: {
      left: '1.875rem',
    },
    checkmark: {
      width: '1rem',
    },
  },
  bestValue: {
    padding: {
      top: '0.625rem',
      right: '0.625rem',
      bottom: '0.625rem',
      left: '0.625rem',
    },
  },
  mobile: {
    border: {
      thickness: '0.03125rem',
      style: 'solid',
    },
    padding: {
      top: '0',
      right: '0.9375rem',
      bottom: '0',
      left: '0.9375rem',
    },
    margin: {
      top: '0',
      right: '0`',
      bottom: '0',
      left: '0',
    },
    toggle: {
      padding: {
        top: '0',
        right: '0.9375rem',
        bottom: '0',
        left: '0.9375rem',
      },
    },
  },
};
